import React from 'react';
import LeafletMap from './LeafletMap';
import CanvasMap from './CanvasMap';
import { useOnline } from '../hooks/useOnline';

/* Chooses Leaflet when online, falls back to canvas offline.
   Setting forceCanvas=true always uses canvas (used on Return-to-Start focus view). */
export default function TrekMap({ points = [], current = null, follow = true, waypoints = [], forceCanvas = false, height = '100%' }) {
  const online = useOnline();
  if (forceCanvas || !online) {
    return <CanvasMap points={points} current={current} waypoints={waypoints} height={height} />;
  }
  return <LeafletMap points={points} current={current} follow={follow} waypoints={waypoints} height={height} />;
}
